<template>
  <section style="height: 100%; display: flex; flex-direction: column; overflow: hidden;">
    <!-- Media views: wrap with breadcrumbs/TOC header -->
    <widget-media-controls-header v-if="showMediaBreadcrumbs"
                                  style="flex: 1; min-height: 0;">
      <component :is="componentInView"
                 style="max-height: 90%; min-height: 50%;" />
    </widget-media-controls-header>
    <component v-else
               :is="componentInView"
               style="flex: 1; min-height: 0; overflow: auto;" />
  </section>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { ProductPageWidgetPages, WidgetErrorPages } from '@/interfaces/global/widgets'
import { useOpenToContent } from '@/components/widgets/composables/useOpenToContent'
import { useWidgetNavigator } from '@/components/widgets/composables/useWidgetNavigator'
import WidgetChapter from '@/components/widgets/components/WidgetChapter'
import WidgetContentError from '@/components/widgets/errorPages/WidgetContentError.vue'
import WidgetInfoPage from '@/components/widgets/components/WidgetInfoPage'
import WidgetMediaControlsHeader from '@/components/widgets/components/WidgetMediaControlsHeader'
import WidgetMediaViewer from '@/components/widgets/components/WidgetMediaViewer'
import WidgetPage from '@/components/widgets/components/WidgetPage'
import WidgetProductPage from '@/components/widgets/views/WidgetProductPage.vue'

const { currentWidgetView, getComponentInViewFromMapping } = useWidgetNavigator()
const { setLandingPage } = useOpenToContent()

const ComponentViews = Object.freeze({
  [ProductPageWidgetPages.productPage]: WidgetProductPage,
  [ProductPageWidgetPages.media]: WidgetMediaViewer,
  [ProductPageWidgetPages.chapter]: WidgetChapter,
  [ProductPageWidgetPages.page]: WidgetPage,
  [ProductPageWidgetPages.info]: WidgetInfoPage,
  [ProductPageWidgetPages.partInfo]: WidgetInfoPage,
  [ProductPageWidgetPages.pageInfo]: WidgetInfoPage,
  [ProductPageWidgetPages.productPageInfo]: WidgetInfoPage,
  [WidgetErrorPages.contentError]: WidgetContentError,
})
const componentInView = computed(getComponentInViewFromMapping(ComponentViews))

const showMediaBreadcrumbs = computed(() => {
  const mediaComponents = new Set([WidgetMediaViewer, WidgetChapter, WidgetPage, WidgetInfoPage])
  return mediaComponents.has(componentInView.value)
})

onMounted(async () => {
  if (currentWidgetView.value !== WidgetErrorPages.contentError) {
    await setLandingPage()
  }
})
</script>
